















import { Vue, Prop, Component } from 'vue-property-decorator'
import Chart from '@/components/Chart/index.vue'
@Component({
  name: 'MainTitle',
  components: { Chart }
})
export default class extends Vue {
  @Prop({ default: '#00B66C' }) private color!: string
  @Prop() private normData!: any
  @Prop() private data!: any
  @Prop() private names!: any
  private chartId: string = ''

  private list: any = [{
    name: '肌肉力量',
    score: 50
  },
  {
    name: '平衡能力',
    score: 50
  },
  {
    name: '身体柔韧',
    score: 50
  }
  ]
  created() {
    this.chartId = new Date().getTime() + '_' + parseInt(Math.random() * 10000000 + '')
    // this.list.map((v, index) => {
    //   this.option.radar.indicator.push({
    //     name: v.name,
    //     max: 100
    //   })
    //   this.option.series[0].data[0].value.push(100)
    //   this.option.series[1].data[0].value.push(100)
    //   this.option.series[1].data[0].name.push(v.score)
    //   this.option.series[2].data[0].value.push(v.score)
    //   this.option.series[3].data[0].value.push(60)
    // })

    this.names.map(v => {
      this.option.radar.indicator.push({
        name: v,
        max: 100
      })
      this.option.series[0].data[0].value.push(100)
      this.option.series[1].data[0].value.push(100)
    })
    this.option.series[1].data[0].name = this.data
    this.option.series[2].data[0].value = this.data
    this.option.series[3].data[0].value = this.normData
  }
  private option: any = {
    color: ['#00B66C'],
    animation: false,
    radar: {
      // startAngle: 60,
      splitNumber: 4,
      radius: '60%',
      splitArea: {
        areaStyle: {
          color: ['#FFFFFF']
        }
      },
      axisLine: {
        lineStyle: {
          color: '#A4E3C9'
        }
      },
      splitLine: {
        lineStyle: {
          color: ['#A4E3C9', '#A4E3C9', '#A4E3C9', '#A4E3C9', '#91CCB4']
        }
      },
      shape: 'circle',
      name: {
        textStyle: {
          color: '#999999',
          fontSize: 12
        },
        formatter: function(value, indicator) {
          if (value === '肌肉爆发力') {
            return `{a|${value}}`
          } else {
            return `${value}`
          }
        },
        rich: {
          a: {
            padding: [10, 0, 0, 0]
          }
        }
      },
      indicator: []
    },
    series: [{
      animation: false,
      name: '',
      type: 'radar',
      symbol: 'circle',
      // symbolSize: 5,
      label: {
        show: true,
        position: 'inside',
        formatter: function(params, ticket, callback) {
          return `{${params.dimensionIndex}|  }`
        },
        rich: {
          0: {
            backgroundColor: '#00B66C',
            borderRadius: 50,
            borderColor: '#ffffff',
            borderWidth: 3,
            height: 10,
            width: 10
          },
          1: {
            backgroundColor: '#00B66C',
            borderRadius: 50,
            borderColor: '#ffffff',
            borderWidth: 3,
            height: 10,
            width: 10
          },
          2: {
            backgroundColor: '#00B66C',
            borderRadius: 50,
            borderColor: '#ffffff',
            borderWidth: 3,
            height: 10,
            width: 10
          },
          3: {
            backgroundColor: '#91CCB4',
            borderRadius: 50,
            borderColor: '#ffffff',
            borderWidth: 3,
            height: 10,
            width: 10
          },
          4: {
            backgroundColor: '#91CCB4',
            borderRadius: 50,
            borderColor: '#ffffff',
            borderWidth: 3,
            height: 10,
            width: 10
          },
          5: {
            backgroundColor: '#91CCB4',
            borderRadius: 50,
            borderColor: '#ffffff',
            borderWidth: 3,
            height: 10,
            width: 10
          },
          6: {
            backgroundColor: '#91CCB4',
            borderRadius: 50,
            borderColor: '#ffffff',
            borderWidth: 3,
            height: 10,
            width: 10
          }
        }
      },
      itemStyle: {
        color: 'none',
        borderColor: 'none',
        borderWidth: 3
      },
      areaStyle: {
        color: 'none'
      },
      lineStyle: {
        color: 'none'
      },
      data: [{
        value: []
      }]
    }, {
      animation: false,
      name: '',
      type: 'radar',
      symbol: 'circle',
      label: {
        show: true,
        position: 'top',
        formatter: function(params, ticket, callback) {
          // const val = params.name[params.dimensionIndex] + '分'
          const val = params.name[params.dimensionIndex]
          return `{${params.dimensionIndex}|${val}}`
        },
        rich: {
          0: {
            color: '#00B66C',
            padding: [2, 0, 0, 0],
            fontWeight: 500,
            fontSize: 12
          },
          1: {
            color: '#00B66C',
            padding: [-60, 70, 0, 0],
            fontWeight: 500,
            fontSize: 12
          },
          2: {
            color: '#00B66C',
            padding: [-60, 0, 0, 70],
            fontWeight: 500,
            fontSize: 12
          },
          3: {
            color: '#91CCB4',
            padding: [-70, 0, 0, 60],
            fontWeight: 500,
            fontSize: 12
          },
          4: {
            color: '#91CCB4',
            padding: [-40, 0, 0, 80],
            fontWeight: 500,
            fontSize: 12
          },
          5: {
            color: '#91CCB4',
            padding: [-50, 0, 0, 50],
            fontWeight: 500,
            fontSize: 12
          },
          6: {
            color: '#91CCB4',
            padding: [-30, 0, 0, 70],
            fontWeight: 500,
            fontSize: 12
          }
        }
      },
      itemStyle: {
        color: 'none',
        borderColor: 'none',
        borderWidth: 3
      },
      areaStyle: {
        color: 'none'
      },
      lineStyle: {
        color: 'none'
      },
      data: [{
        value: [],
        name: []
      }]
    }, {
      // animation: false,
      name: '',
      type: 'radar',
      symbol: 'none',
      itemStyle: {
        normal: {
          areaStyle: {
            color: 'rgba(0, 182, 108, 0.23)'
          }
        }
      },
      data: [{
        value: [],
        name: ''
      }],
      z: 10
    }, {
      // animation: false,
      name: '',
      type: 'radar',
      symbol: 'none',
      itemStyle: {
        normal: {
          areaStyle: {
            color: '#FFFFFF'
          }
        }
      },
      lineStyle: {
        color: '#666666',
        type: 'dotted'
      },
      data: [{
        value: [],
        name: ''
      }]
    }]
  }
}
